import {Connection} from "@/modules/Rhizome/interfaces/connection.interface";

class DataSource {
  parse( data ) {
    if (data['keywords']) {
      const parsed = {};
      const keywords = [];

      for (const item of data['keywords']) {
        if (!parsed[item.keyword]) {
          parsed[item.keyword] = {
            entity_id: item.entity_id,
            keyword: item.keyword,
            timecodes: [
              {
                start: Number(item.jump_time_start),
                end: Number(item.jump_time_end),
              }
            ]
          }
        }
        else {
          const existedKeywords = parsed[item.keyword].timecodes.filter(
            word =>
              (word.start <= item.jump_time_start && item.jump_time_start <= word.end) ||
              (word.start <= item.jump_time_end && item.jump_time_end <= word.end)
          )
          if (existedKeywords.length) {
            existedKeywords[0].start = Math.min(existedKeywords[0].start, item.jump_time_start)
            existedKeywords[0].end = Math.max(existedKeywords[0].end, item.jump_time_end)
          }
          else {
            parsed[item.keyword].timecodes.push({
              start: Number(item.jump_time_start),
              end: Number(item.jump_time_end),
            })
          }
        }
      }

      for (const item in parsed) {
        keywords.push(parsed[item]);
      }
      data['keywords'] = keywords;
    }
    if (data['related_films']) {
      const relatedFilms = [];
      for (const item of data['related_films']) {
        const commonKeywords = [];

        for (const word in item['common_keywords']) {
          commonKeywords.push({
            entity_id: word,
            keyword: item['common_keywords'][word],
          })
        }

        relatedFilms.push({
          entity_id: item.entity_id,
          title: item.title,
          director: item.director,
          year: item.year,
          thumbnail: item.thumbnail,
          common_keywords: commonKeywords,
          connectionWidth: this.getConnectionWidth(item.line_width),
        })
      }
      data['relatedFilms'] = relatedFilms;
    }

    return data;
  }

  private getConnectionWidth(connection: Connection.IConnectionLineType) {
    let width = 0;
    switch (connection) {
      case Connection.IConnectionLineType.ONE:
        width = 0.5;
        break;
      case Connection.IConnectionLineType.FEW:
        width = 1;
        break;
      case Connection.IConnectionLineType.MORE:
        width = 2;
        break;
      case Connection.IConnectionLineType.MANY:
        width = 3;
        break;
    }
    return width;
  }
}

export const detailPageDataSource = new DataSource();
